import React, { useContext, useEffect } from "react";
import { getSortedCostCenters, initialCostCenterFilter } from "./FilterTypes/CostCenterFilterType";
import { FilterContext } from "../FilterContext";
import { areArrayValuesEqual } from "../FilterGroups/instructionUtils";
import MultiPickerFilterPopup from "./MultiPickerFilterPopup";
import MultiCostCenterList from "components/Picker/CostCenterPicker/MultiCostCenterList";

const CostCenterFilter = () => {
  const title = RESX.CostCenter.resxCostCenter;

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  register("costCenter", {
    getTitle: () => title,
    renderSelection: (filter) => <>{getSortedCostCenters(filter).join(", ")}</>,
    hasValue: (filter) => filter.selectedCostCenters.length > 0,
    reset: () => initialCostCenterFilter,
    areEqual: (a, b) => areArrayValuesEqual(a.selectedCostCenters.map(c => c.costCenterId), b.selectedCostCenters.map(c => c.costCenterId))
  });
  useEffect(() => {
    setInitialValue("costCenter", initialCostCenterFilter);
  }, []);

  const [selectedCostCenters, setSelectedCostCenters] = React.useState<server.dto.CostCenter[]>(initialCostCenterFilter.selectedCostCenters);
  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);

  const onPopupClose = () => {
    onApply();
  };

  const onPopupOpen = () => {
    setSelectedCostCenters(getValue("costCenter").selectedCostCenters);
    setPopupOpen(true);
  };

  const onApply = (e?) => {
    e?.preventDefault();
    setValue("costCenter", {
      selectedCostCenters
    });
    setPopupOpen(false);
  };

  if (!site.currentEnvironment.hasCostCenters) return <></>;

  return <div>
    <MultiPickerFilterPopup
      title={title}
      minHeight={350}
      width={400}
      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
      onApply={onApply}
    >
      <MultiCostCenterList
        value={selectedCostCenters}
        onChange={setSelectedCostCenters}

      />
    </MultiPickerFilterPopup>
  </div>;
};

export default CostCenterFilter;
